export default __webpack_public_path__ + "static/media/21.4d0ed691.png";